import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { useUserHasConsignorMasterUI } from 'src/hooks/useUserIsConsignorMasterUI';
import { SellerAccountClient } from 'src/WebApiController';

export function useConsigneeAccountInfo() {
  const { activeAccountWebClientConfig } = useAppContext();
  const { showErrorDialog } = useClientLogContext();

  const hasConsignorMasterUI = useUserHasConsignorMasterUI();
  const shouldQuery =
    hasConsignorMasterUI &&
    activeAccountWebClientConfig.activeAccountId != null;

  const query = useQuery({
    queryKey: [
      'getConsigneeSellerAccounts',
      activeAccountWebClientConfig.activeAccountId,
      shouldQuery,
    ],
    queryFn: async () => {
      if (!shouldQuery) {
        return null;
      }
      return await new SellerAccountClient(
        activeAccountWebClientConfig
      ).getConsigneeSellerAccounts();
    },

    enabled: shouldQuery,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    meta: {
      onError: (error: ErrorTypes) => {
        showErrorDialog(
          'SellerAccountClient.getConsigneeSellerAccounts',
          error
        );
      },
    },
  });

  return query;
}
